/* eslint-disable no-console */
import logger from './logger'

/**
 * 로그를 JSON 형식으로 포맷팅
 */
function formatArgs(args: unknown[]): { msg: string; err?: Error } {
  const err = args.find((a): a is Error => a instanceof Error)
  const msgParts = args
    .filter(a => !(a instanceof Error))
    .map(a => (typeof a === 'string' ? a : JSON.stringify(a)))

  return {
    msg: msgParts.join(' ') || err?.message || '',
    ...(err && { err }),
  }
}

export function overrideConsole() {
  console.log = (...args: unknown[]) => {
    const { msg } = formatArgs(args)
    logger.info(msg)
  }

  console.info = (...args: unknown[]) => {
    const { msg } = formatArgs(args)
    logger.info(msg)
  }

  console.warn = (...args: unknown[]) => {
    const { msg, err } = formatArgs(args)
    if (err) {
      logger.warn({ err }, msg)
    } else {
      logger.warn(msg)
    }
  }

  console.error = (...args: unknown[]) => {
    const { msg, err } = formatArgs(args)
    if (err) {
      logger.error({ err }, msg)
    } else {
      logger.error(msg)
    }
  }

  console.debug = (...args: unknown[]) => {
    const { msg } = formatArgs(args)
    logger.debug(msg)
  }
}
